import { useMemo } from "react";

import * as COLUMNS_AVAILABLE from "b2b/components/uzivatele-grid-columns/columnsAvailable";

export default function useColumns() {
  const columns = [
    COLUMNS_AVAILABLE.jmeno(),
    COLUMNS_AVAILABLE.telefon(),
    COLUMNS_AVAILABLE.email(),
    COLUMNS_AVAILABLE.role()
  ];
  return useMemo(() => [columns], []);
}
